import { Component, OnInit, Input, Inject,ChangeDetectorRef} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { DOCUMENT } from '@angular/common';

import { NotificationService } from '@progress/kendo-angular-notification';
import { ShareService } from '@global/shared.service';
import * as XLSX from 'xlsx';

import {AutopassService} from '../../Autopass/service/autopass.service';

import { OptionDTO } from '../../model/OptionDTO';
import { RuleAppliedDTO  } from '../../model/RuleAppliedDTO';
import { RuleAppliedPropertyDTO  } from '../../model/RuleAppliedPropertyDTO';
import { FilterLineDTO  } from '../../model/FilterLineDTO';
import { QueryBuilderFilterRuleDTO } from '../../model/QueryBuilderFilterRuleDTO';
import { QueryBuilderFilterLineRuleDTO } from '../../model/QueryBuilderFilterLineRuleDTO';

import Utils from '../../../helpers/Util';
import UtilRules from '../../helper/UtilRules';

import { QueryBuilderConfig, DataTypeParent, DataTypeChildren, DataTypeBuilder, FilterClientCarrierIdDto } from '../../../commoncomponent/QueryBuilderAutopass/query-builder/query-builder.interfaces';
import { QueryBuilderService } from '../../../commoncomponent/QueryBuilderAutopass/query-builder/query-builder.service';
import { DATA_TYPE_CHILDREN_VALIDATION, DATA_TYPE_PARENT_VALIDATION, INVOICE_TYPE, QUERYBUILDER_PROPERTIES, QUERYBUILDER_PROPERTIES_VALIDATION } from '../../rule.interface'

import { ValidationService } from '../service/validation-service';

@Component({
  selector: 'validationform',
  styleUrls: ['../../rule.scss','../../Autopass/autopassform.component.scss','../validation.component.scss'],
  templateUrl: 'validation-form.html',
})

export class ValidationForm implements OnInit {
  //filter variable here

  @Input() filter;

  RuleType: string = 'Validation'

  dropDownPage:number = 0;
  dropDownpageSize:number = 10;
  query:FilterLineDTO;

  show: boolean = false;

  public queryNew = {
      condition: 'and',
      dataType: '',
      rules: [
      ]
  };

  public dataTypeParent: Array<DataTypeParent> = DATA_TYPE_PARENT_VALIDATION;
  public dataTypeChildren: Array<DataTypeChildren> = DATA_TYPE_CHILDREN_VALIDATION;
  public config: QueryBuilderConfig = QUERYBUILDER_PROPERTIES_VALIDATION;
  
  //rules variable here
  ruleLeft:Array<RuleAppliedPropertyDTO> = [];
  ruleRight:Array<RuleAppliedDTO> = [];
  selectedRightRule:any;
  entityDropDown:any;
  fieldDropDown:any;
  excelData: any[][];
  page:number = 0;
  pageClientId:number = 0;
  pageSize:number = 10;
  pageClientCode:number = 0;
  pageClientRegion:number = 0;
  pageClientCountry:number = 0;
  pageClientCTLocation:number = 0;
  pageClientCity:number = 0;
  pageClientParent:number = 0;
  pageClientFullName:number = 0;
  pageClientDivision:number = 0;
  pageClientSubDivision:number = 0;
  pageClientLocation:number = 0;
  pageClientSubLocation:number = 0;
  pageClientCounty:number = 0;
  pageCarrierId:number = 0;
  pageCarrierName:number = 0;
  pageCarrierTitle:number = 0;
  pageCarrierCode:number = 0;
  pageCarrierRegion:number = 0;
  pageCarrierLocation:number = 0;
  pageCarrierSubLocation:number = 0;
  pageCarrierCurrency:number = 0;
  pageCarrierCountry:number = 0;
  pageCarrierCity:number = 0;
  pageCarrierPostcode:number = 0;
  pageClientCarrierId:number = 0;
  pageClientCarrierGP1:number = 0;
  pageClientCarrierGP2:number = 0;
  pageCurrency:number = 0;
  pageReasonCodes: number = 0;
  pageStatus:number = 0;
  pageShipmentMode:number = 0;
  pageServiceLevel:number = 0;
  pageOriginPostcode:number = 0;
  pageDestinationPostcode:number = 0;
  pageFreightTerms:number = 0;
  pageOriginCountryCode:number = 0;
  pageDestinationPortcode:number = 0;
  pageShipmentCurrency:number = 0;
  pageOrigin:number = 0;
  pageOriginCity:number = 0;
  pageAccessorial:number = 0;
  isInitProperyDropDown:boolean = false;
  isSaveAsFilter:boolean = false;

  public dataTypeBuilder: DataTypeBuilder;
  public queryCtrl: UntypedFormControl;

  DefaultDataType: string = "ValidationRule"
  listsCurrency: Array<any> = [];
  listsInvoiceSource: Array<any> = [];
  listsReasonCodes: Array<any> = [];

  public allowRuleset: boolean = true;
  public allowCollapse: boolean;
  public persistValueOnFieldChange: boolean = false;  

  filterForFilterClientId: Array<FilterClientCarrierIdDto> = [];

  invoiceTypes: Array<any> = INVOICE_TYPE;

  constructor(
    private _autopassService: AutopassService,
    private _notificationService: NotificationService,  
    @Inject(DOCUMENT) private _document: Document,
    private _sharedService: ShareService,
    private queryS: QueryBuilderService,
    private formBuilder: UntypedFormBuilder,
    private validationService: ValidationService,
    private changeDetectorRef: ChangeDetectorRef) {

      this.dataTypeBuilder = { fields: this.dataTypeParent }
      this.queryCtrl = this.formBuilder.control(this.queryNew);
      // this.queryS.changeEmitted$.subscribe(data => {
      //   this.onfetchMoreConditionalData(data);
      // });
  }

  ngOnInit()  {

    this._autopassService.GetAutopassConditionFields().subscribe(data => {    
      this.config.conditionQueryBuilderConfig.fields = data;
      this.initFilterDropDown();
      this.show = true;

      this.initFilterLine();
      this.initRules();
      this.isInitProperyDropDown = false;
    });
  }

  public onExportExcel($e){
    var rule = $e;
    const fileName = 'DropDownValue.xlsx';
    var data = [];
    rule.value.forEach(element => {
      var x = {element};
      data.push( {element}); 
    });

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data,{skipHeader: true});
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws);

		XLSX.writeFile(wb, fileName);
  }

  public onFileChange($e){
    /* wire up file reader */
    var evt = $e.event;
    var rule = $e.rule;
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.excelData = <any>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      var data = [];
      this.excelData.forEach(x=>{
        data.push(x.toString())
      })
      rule.value = data;
    };
    reader.readAsBinaryString(target.files[0]);
    this.changeDetectorRef.detectChanges();
  }

  public initFilterDropDown(){

    this.config.conditionQueryBuilderConfig.fields["invoiceType"].options = this.invoiceTypes;

    this._autopassService.GetReasonCodes(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => { 
        this.listsReasonCodes = data;
    });

    this._autopassService.GetClientCode(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) =>  { 
      this.config.conditionQueryBuilderConfig.fields["clientName"].options = data;
    });

    this._autopassService.GetClientRegion(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => { 
      this.config.conditionQueryBuilderConfig.fields["clientRegion"].options = data;
    });

    this._autopassService.GetClientCountryCode(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) =>{ 
      this.config.conditionQueryBuilderConfig.fields["clientCountry"].options = data;
    });

    this._autopassService.GetClientCity(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["clientCity"].options = data;
    });

    this._autopassService.GetClientDivision(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["clientDivision"].options = data;
    });

    this._autopassService.GetClientSubDivision(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["clientSubDivision"].options = data;
    });

    this._autopassService.GetClientLocation(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["clientLocation"].options = data;
    });

    this._autopassService.GetClientSubLocation(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["clientSubLocation"].options = data;
    });

    this._autopassService.GetCarrierID(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["carrierId"].options = data;
    });

    this._autopassService.GetCarrierShortName(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["carrierName"].options = data;
    });

    this._autopassService.GetCarrierSCAC(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["carrierCode"].options = data;
    });

    this._autopassService.GetCurrency(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["shipmentCurrency"].options = data;
      this.config.conditionQueryBuilderConfig.fields["invoiceCurrency"].options = data;
      this.listsCurrency = data;
    });

    this._autopassService.GetShipMode(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["shipmentMode"].options = data;
    });

    this._autopassService.GetSrvceType(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["serviceType"].options = data;
    });

    this._autopassService.GetFreightTerm(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["freightTerms"].options = data;
    });
    
    this._autopassService.GetCountryCode(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["originCountryCode"].options = data;
    });

    this._autopassService.GetUOM().subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["uomType"].options = data;
    });

    this._autopassService.GetInvoiceIdsListDropDown(this.filter.ClientCode,this.page,this.pageSize,this.filter).subscribe((data:Array<any>) =>
    {
      this.config.conditionQueryBuilderConfig.fields["invoiceIdName"].options = data;
      this.changeDetectorRef.detectChanges();
    });

    this._autopassService.GetAllAccessorial().subscribe((data:Array<any>) =>
    {
      this.config.conditionQueryBuilderConfig.fields["invoiceChargeType"].options = data;
      this.changeDetectorRef.detectChanges();
    })

    this._autopassService.GetClientField(this.filter.ClientCode).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["clientFieldName"].options = data;
    });

    this._autopassService.GetSID().subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.conditionQueryBuilderConfig.fields["sidName"].options = data;
    });
  }

  public initFilterLine(){

    this.query = { id:0, field: "", value:[], entity:"", condition: 'and', type: 'Autopass', rules: [], collapsed:"",isChild:"" } as FilterLineDTO;

    if(this.filter.Id != 0){
      this._autopassService.GetFilterLineWithChildAutopass(this.filter.Id).subscribe((data:any) => 
      {
        var formedObject = this.generate(data);
        this.queryNew = formedObject;
        this.queryCtrl.patchValue(this.queryNew);
      });
    }
  }

  SPECIAL_CASES_GET_VALUE(data: any){
    if(data.Value?.length > 0 && data.Field == 'invoiceType'){
      return parseInt(data.Value[0]);
    }
    return data.Value;
  }

  CHECK_CHILDREN_COMPARE(mappedArr: Array<any>, mappedElem: any){
    var foundChildren = null;

    for (const [key, value] of Object.entries(mappedArr)) {
      if(mappedElem.Id == value.ParentId){
        foundChildren = value;
      }
    }

    if(foundChildren != null){
      return[
        {
          field: foundChildren.Field,
          operator: foundChildren.Operator,
          entity: foundChildren.DataType
        }
      ]
    }
    return [];
  }

  generate(arr: any){
    var tree: any = {},
    mappedArr = {},
    arrElem,
    mappedElem;

    for(var i = 0, len = arr.length; i < len; i++) {
      arrElem = arr[i];
      mappedArr[arrElem.Id] = arrElem;      
      mappedArr[arrElem.Id]['rules'] = [];
    }
    
    for (var id in mappedArr) {

      if (mappedArr.hasOwnProperty(id)) {
        let obj$;
        mappedElem = mappedArr[id];

        if (mappedElem.ParentId) {              
          // INTEGER
          if(mappedElem.Context == 'Integer'){            
            if(mappedElem.DataType &&  mappedElem.DataType != 'Condition'){
              obj$ = {             
                field: mappedElem.Field,
                operator: mappedElem.Operator,                
                entity: mappedElem.DataType,
                value: this.SPECIAL_CASES_GET_VALUE(mappedElem),
                compare: this.CHECK_CHILDREN_COMPARE(mappedArr as Array<any>, mappedElem)
              }              
              mappedArr[mappedElem['ParentId']]['rules'].push(obj$);
              continue;
            }

            if(mappedElem.Field && mappedElem.Value){
              obj$ = {             
                field: mappedElem.Field,
                operator: mappedElem.Operator,
                value: mappedElem.Value[0]
              }
              mappedArr[mappedElem['ParentId']]['rules'].push(obj$);
              continue;
            }
            
          }

          // STRING
          if(mappedElem.Context == 'String'){

            if(mappedElem.DataType &&  mappedElem.DataType != 'Condition'){
              obj$ = {             
                field: mappedElem.Field,
                operator: mappedElem.Operator,                
                entity: mappedElem.DataType,
                value: this.CHECK_BOOLEAN_VALUE(mappedElem.Value[0]),
                compare: this.CHECK_CHILDREN_COMPARE(mappedArr as Array<any>, mappedElem)
              }              
              mappedArr[mappedElem['ParentId']]['rules'].push(obj$);
              continue;
            }

            if(mappedElem.Field && mappedElem.Value){
              obj$ = {             
                field: mappedElem.Field,
                operator: mappedElem.Operator,
                value: this.CHECK_BOOLEAN_VALUE(mappedElem.Value[0])
              }
              mappedArr[mappedElem['ParentId']]['rules'].push(obj$);
              continue;
            }
          }

          // Date
          if(mappedElem.Context == 'Date'){

            if(mappedElem.DataType &&  mappedElem.DataType != 'Condition'){
              obj$ = {             
                field: mappedElem.Field,
                operator: mappedElem.Operator,                
                entity: mappedElem.DataType,
                value: mappedElem.Value[0],
                compare: this.CHECK_CHILDREN_COMPARE(mappedArr as Array<any>, mappedElem)
              }              
              mappedArr[mappedElem['ParentId']]['rules'].push(obj$);
              continue;
            }

            if(mappedElem.Field && mappedElem.Value){
              obj$ = {             
                field: mappedElem.Field,
                operator: mappedElem.Operator,
                value: mappedElem.Value[0]
              }
              mappedArr[mappedElem['ParentId']]['rules'].push(obj$);
              continue;
            }
          }

          // BOOLEAN
          if(mappedElem.Context == 'Boolean'){

            if(mappedElem.DataType &&  mappedElem.DataType != 'Condition'){
              obj$ = {             
                field: mappedElem.Field,
                operator: mappedElem.Operator,                
                entity: mappedElem.DataType,
                value: mappedElem.Value[0] == 'True' ? true : false,
                compare: this.CHECK_CHILDREN_COMPARE(mappedArr as Array<any>, mappedElem)
              }              
              mappedArr[mappedElem['ParentId']]['rules'].push(obj$);
              continue;
            }

            if(mappedElem.DataType && mappedElem.Field && mappedElem.Operator){
              obj$ = {             
                field: mappedElem.Field,
                operator: mappedElem.Operator,
                value: mappedElem.Value[0] == 'True' ? true : false
              }
              mappedArr[mappedElem['ParentId']]['rules'].push(obj$);
              continue;
            }

             if(mappedElem.Field && mappedElem.Value){
              obj$ = {             
                field: mappedElem.Field,
                operator: mappedElem.Operator,
                value: mappedElem.Value[0] == 'True' ? true : false
              }
              mappedArr[mappedElem['ParentId']]['rules'].push(obj$);
              continue;
            }
          }

          // ARRAY
          if(mappedElem.Context == 'Array'){
            if(mappedElem.DataType &&  mappedElem.DataType != 'Condition' && mappedElem.Value != null){
              obj$ = {             
                field: mappedElem.Field,
                operator: mappedElem.Operator,
                value: this.SPECIAL_CASES_GET_VALUE(mappedElem),
                entity: mappedElem.DataType,
                compare: this.CHECK_CHILDREN_COMPARE(mappedArr as Array<any>, mappedElem)
              }
              mappedArr[mappedElem['ParentId']]['rules'].push(obj$);
              continue;
            }

            if(!mappedElem.DataType &&  mappedElem.DataType != 'Condition' && mappedElem.Value != null){
              obj$ = {             
                field: mappedElem.Field,
                operator: mappedElem.Operator,
                value: mappedElem.Value,
              }
              mappedArr[mappedElem['ParentId']]['rules'].push(obj$);
              continue;
            }
          }

          // FLOAT
          if(mappedElem.Context == 'Float'){            
            if(mappedElem.DataType &&  mappedElem.DataType != 'Condition'){
              obj$ = {             
                field: mappedElem.Field,
                operator: mappedElem.Operator,                
                entity: mappedElem.DataType,
                value: mappedElem.Value[0],
                compare: this.CHECK_CHILDREN_COMPARE(mappedArr as Array<any>, mappedElem)
              }              
              mappedArr[mappedElem['ParentId']]['rules'].push(obj$);
              continue;
            }

            if(mappedElem.Field && mappedElem.Value){
              obj$ = {             
                field: mappedElem.Field,
                operator: mappedElem.Operator,
                value: mappedElem.Value[0]
              }
              mappedArr[mappedElem['ParentId']]['rules'].push(obj$);
              continue;
            }
            
          }

          
          if(mappedElem.DataType &&  mappedElem.DataType != 'Condition' && !(mappedElem.Value)){
            let obj$ = {
              dataType: mappedElem.DataType,
              condition: mappedElem.Condition,
              rules: mappedElem.rules,
              compare: this.CHECK_CHILDREN_COMPARE(mappedArr as Array<any>, mappedElem)
            }
            mappedArr[mappedElem['ParentId']]['rules'].push(obj$);
            continue;
          }

          if(mappedElem.DataType && mappedElem.DataType == 'Condition' && mappedElem.Value == null){
            let obj$ = {
              dataType: mappedElem.DataType,
              condition: mappedElem.Condition,
              rules: mappedElem.rules
            }
            mappedArr[mappedElem['ParentId']]['rules'].push(obj$);
            continue;
          }

        }

        else {
          tree = mappedElem;
        }
      }
    }

    return {
      dataType: tree.DataType,
      condition: tree.Condition,
      rules: tree.rules
    };
  }

  CHECK_BOOLEAN_VALUE(data: any){
    if(data == 'True'){
      return true;
    } 

    if(data == 'False'){
      return false;
    }
     return data;
  }

  public initRules() {
    if(this.filter.Id == 0){
      this.ruleRight = [];
    }else{  

    }
  }

  public sucessMessage(){
    this._notificationService.show({
      content: 'Successfully saved!',
      animation: { type: 'fade', 
      duration: 500 },
      type: { style: 'info', icon: true }
     });
  }

  public sucessUpdateMessage(){
    this._notificationService.show({
      content: 'Successfully updated!',
      animation: { type: 'fade', 
      duration: 500 },
      type: { style: 'info', icon: true }
    });
  }

  onfetchMoreReasonCodes(){
    this.pageReasonCodes = this.pageReasonCodes + 1;
    this._autopassService.GetReasonCodes(this.pageReasonCodes,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.listsReasonCodes.push(...data);
    });
  }

  onfetchMoreCurrency(){
    this.pageCurrency = this.pageCurrency + 1;
    this._autopassService.GetCurrency(this.pageCurrency,this.pageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.listsCurrency.push(...data);
    });
  }
  
  onfetchMoreData(rule: any) {
    if(rule.field == 'ClientId'){
      this.pageClientId = this.pageClientId + 1;
      this._autopassService.GetClientId(this.pageClientId,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig.fields["Invoice.Client.ClientId"].options.push(...data);
      });
    }else if(rule.field == 'Invoice.Client.Code'){
      this.pageClientCode = this.pageClientCode + 1;
      this._autopassService.GetClientCode(this.pageClientCode,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        if(data.length > 0){
          this.config.conditionQueryBuilderConfig['Invoice.Client.Code'].options.push(...data);
        }
      });
    }else if(rule.field == 'Client.Region'){
      this.pageClientRegion = this.pageClientRegion + 1;
      this._autopassService.GetClientRegion(this.pageClientRegion,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Client.Region"].options.push(...data);
      });
    }else if(rule.field == 'Invoice.Client.Address.Country'){
      this.pageClientCountry = this.pageClientCountry + 1;
      this._autopassService.GetCTClientCountry(this.pageClientCountry,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Client.Country"].options.push(...data);
      });
    }else if(rule.field == 'Invoice.Client.Location'){
      this.pageClientCTLocation = this.pageClientCTLocation + 1;
      this._autopassService.GetCTClientCity(this.pageClientCTLocation,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Invoice.Client.Location"].options.push(...data);
      });

    }else if(rule.field == 'Invoice.Client.Address.City'){
      this.pageClientCity = this.pageClientCity + 1;
      this._autopassService.GetClientCity(this.pageClientCity,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Invoice.Client.Address.City"].options.push(...data);
      });
    }
    else if(rule.field == 'Client.CtClientParent'){
      this.pageClientParent = this.pageClientParent + 1;
      this._autopassService.GetCTClientParentName(this.pageClientParent,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Client.CtClientParent"].options.push(...data);
      });
    }else if(rule.field == 'Client.FullName'){
      this.pageClientFullName = this.pageClientFullName + 1;
      this._autopassService.GetCTClientFullName(this.pageClientFullName,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Client.FullName"].options.push(...data);
      });
    }else if(rule.field == 'Invoice.Client.Division'){
      this.pageClientDivision = this.pageClientDivision + 1;
      this._autopassService.GetClientDivision(this.pageClientDivision,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Invoice.Client.Division"].options.push(...data);
      });
    } else if(rule.field == 'Invoice.Client.SubDivision'){
      this.pageClientSubDivision = this.pageClientSubDivision + 1;
      this._autopassService.GetClientSubDivision(this.pageClientSubDivision,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Invoice.Client.SubDivision"].options.push(...data);
      });
    } else if(rule.field == 'Invoice.Client.Location'){
      this.pageClientLocation = this.pageClientLocation + 1;
      this._autopassService.GetClientLocation(this.pageClientLocation,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Invoice.Client.Location"].options.push(...data);
      });
    } else if(rule.field == 'Invoice.Client.SubLocation'){
      this.pageClientSubLocation = this.pageClientSubLocation + 1;
      this._autopassService.GetClientSubLocation(this.pageClientSubLocation,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Invoice.Client.SubLocation"].options.push(...data);
      });
    } else if(rule.field == 'Invoice.Client.Address.Country'){
      this.pageClientCountry = this.pageClientCountry + 1;
      this._autopassService.GetClientCountryCode(this.pageClientCountry,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Invoice.Client.Address.Country"].options.push(...data);
      });
    } else if(rule.field == 'County'){
      this.pageClientCounty = this.pageClientCounty + 1;
      this._autopassService.GetClientCountyCode(this.pageClientCounty,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Client.County"].options.push(...data);
      });
    } else if(rule.field == 'Invoice.CarrierId'){
      this.pageCarrierId = this.pageCarrierId + 1;
      this._autopassService.GetCarrierID(this.pageCarrierId,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Invoice.CarrierId"].options.push(...data);
      });
    } else if(rule.field == 'Carrier.Name'){
      this.pageCarrierName = this.pageCarrierName + 1;
      this._autopassService.GetCarrierShortName(this.pageCarrierName,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Carrier.Name"].options.push(...data);
      });
    } else if(rule.field == 'Carrier.Title'){
      this.pageCarrierTitle = this.pageCarrierTitle + 1;
      this._autopassService.GetCarrierFullName(this.pageCarrierTitle,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Carrier.Title"].options.push(...data);
      });
    } else if(rule.field == 'Carrier.Code'){
      this.pageCarrierCode = this.pageCarrierCode + 1;
      this._autopassService.GetCarrierSCAC(this.pageCarrierCode,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Carrier.Code"].options.push(...data);
      });
    } else if(rule.field == 'Carrier.Region'){
      this.pageCarrierRegion = this.pageCarrierRegion + 1;
      this._autopassService.GetCarrierRegion(this.pageCarrierRegion,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Carrier.Region"].options.push(...data);
      });
    } else if(rule.field == 'Carrier.Location'){
      this.pageCarrierLocation = this.pageCarrierLocation + 1;
      this._autopassService.GetCarrierLocation(this.pageCarrierLocation,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig['Carrier.Location'].options.push(...data);
      });
    } else if(rule.field == 'Carrier.SubLocation'){
      this.pageCarrierSubLocation = this.pageCarrierSubLocation + 1;
      this._autopassService.GetCarrierSubLocation(this.pageCarrierSubLocation,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Carrier.SubLocation"].options.push(...data);
      });
    } else if(rule.field == 'CarrierCurrency'){
      this.pageCarrierCurrency = this.pageCarrierCurrency + 1;
      this._autopassService.GetCarrierCurrency(this.pageCarrierCurrency,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig['CarrierCurrency'].options.push(...data);
      });
    } else if(rule.field == 'Carrier.Country'){
      this.pageCarrierCountry = this.pageCarrierCountry + 1;
      this._autopassService.GetCarrierCountryCode(this.pageCarrierCountry,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig['Carrier.Country'].options.push(...data);
      });
    } else if(rule.field == 'Carrier.City'){
      this.pageCarrierCity = this.pageCarrierCity + 1;
      this._autopassService.GetCarrierCity(this.pageCarrierCity,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Carrier.City"].options.push(...data);
      });
    } else if(rule.field == 'Carrier.Postcode'){
      this.pageCarrierPostcode = this.pageCarrierPostcode + 1;
      this._autopassService.GetCarrierPostCode(this.pageCarrierPostcode,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Carrier.Postcode"].options.push(...data);
      });
    }
    if(rule.field == 'ClientCarrier.ClientCarrierId'){
      this.pageClientCarrierId = this.pageClientCarrierId + 1;
      this._autopassService.GetClientCarrierId(this.pageClientCarrierId,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["ClientCarrier.ClientCarrierId"].options.push(...data);
      });
    } else if(rule.field == 'ClientCarrier.GP1'){
      this.pageClientCarrierGP1 = this.pageClientCarrierGP1 + 1;
      this._autopassService.GetClientCarrierGP1(this.pageClientCarrierGP1,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["ClientCarrier.GP1"].options.push(...data);
      });
    } else if(rule.field == 'ClientCarrier.GP2'){
      this.pageClientCarrierGP2 = this.pageClientCarrierGP2 + 1;
      this._autopassService.GetClientCarrierGP2(this.pageClientCarrierGP2,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["ClientCarrier.GP2"].options.push(...data);
      });
    }

    if(rule.field == 'Currency'){
      this.pageCurrency = this.pageCurrency + 1;
      this._autopassService.GetCurrency(this.pageCurrency,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.Currency.options.push(...data);
      });
    } else if(rule.field == 'Status'){
      this.pageStatus = this.pageStatus + 1;
      this._autopassService.GetInvoiceStatus(this.pageStatus,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["Status"].options.push(...data);
      });
    } else if(rule.field == 'InvoiceShipment.ShipmentMode'){
      this.pageShipmentMode = this.pageShipmentMode + 1;
      this._autopassService.GetShipMode(this.pageShipmentMode,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["InvoiceShipment.ShipmentMode"].options.push(...data);
      });
    } else if(rule.field == 'InvoiceShipment.ServiceLevel'){
      this.pageServiceLevel = this.pageServiceLevel + 1;
      this._autopassService.GetSrvceType(this.pageServiceLevel,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["InvoiceShipment.ServiceLevel"].options.push(...data);
      });
    } else if(rule.field == 'InvoiceShipment.OriginPostcode'){
      this.pageOriginPostcode = this.pageOriginPostcode + 1;
    } else if(rule.field == 'InvoiceShipment.DestinationPostcode'){
      this.pageDestinationPostcode = this.pageDestinationPostcode + 1;
    } else if(rule.field == 'InvoiceShipment.FreightTerms'){
      this.pageFreightTerms = this.pageFreightTerms + 1;
      this._autopassService.GetFreightTerm(this.pageFreightTerms,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["InvoiceShipment.FreightTerms"].options.push(...data);
      });
    } else if(rule.field == 'InvoiceShipment.OriginCountryCode' ){
      this.pageOriginCountryCode = this.pageOriginCountryCode + 1;
      this._autopassService.GetCountryCode(this.pageOriginCountryCode,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["InvoiceShipment.OriginCountryCode"].options.push(...data);
      });
    } else if(rule.field == 'InvoiceShipment.DestinationPortcode'){
      this.pageDestinationPortcode = this.pageDestinationPortcode + 1;
      this._autopassService.GetGeoPortCode(this.pageDestinationPortcode,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["InvoiceShipment.DestinationPortcode"].options.push(...data);
      });
    }else if(rule.field == 'InvoiceShipment.ShipmentCurrency'){
        this.pageShipmentCurrency = this.pageShipmentCurrency + 1;
        this._autopassService.GetCurrency(this.pageShipmentCurrency,this.pageSize).subscribe((data:Array<OptionDTO>) => 
        { 
          this.config.conditionQueryBuilderConfig["InvoiceShipment.ShipmentCurrency"].options.push(...data);
        });
    } else if(rule.field == 'InvoiceShipment.Origin' ){
      this.pageOrigin = this.pageOrigin + 1;
      this._autopassService.GetShipmentOriginState(this.pageOrigin,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["InvoiceShipment.Origin"].options.push(...data);
      });
    } else if(rule.field == 'InvoiceShipment.OriginCity'){
      this.pageOriginCity = this.pageOriginCity + 1;
      this._autopassService.GetShipmentCity(this.pageOriginCity,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.conditionQueryBuilderConfig["InvoiceShipment.OriginCity"].options.push(...data);
      });
    } else if(rule.field == 'Accessorial'){
      this.pageAccessorial = this.pageAccessorial + 1;
      this._autopassService.GetAccessorialName(this.pageAccessorial,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.Accessorial.options.push(...data);
      });
    }
  }

  onSearch($event){
    if($event.field == 'Invoice.Client.ClientId'){
      this._autopassService.GetClientIdByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Invoice.Client.ClientId"].options = data;
      });
    }else if($event.field == 'Invoice.Client.Code'){
      this._autopassService.GetClientCodeByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Invoice.Client.Code"].options = data;
      });
    }else if($event.field == 'Client.Region'){
      this._autopassService.GetClientRegionByFilter(0,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.Region"].options = data;
      });
    }else if($event.field == 'Invoice.Client.Address.Country'){
      this._autopassService.GetCTClientCountryByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Invoice.Client.Address.Country"].options = data;
      });
    }else if($event.field == 'Invoice.Client.Location'){
      this._autopassService.GetCTClientCityByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Invoice.Client.Location"].options = data;
      });
    }else if($event.field == 'Client.CtClientParent'){
      this._autopassService.GetCTClientParentNameByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.CtClientParent"].options = data;
      });
    }else if($event.field == 'Client.FullName'){
      this._autopassService.GetCTClientFullNameByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.FullName"].options = data;
      });
    }else if($event.field == 'Invoice.Client.Division'){
      this._autopassService.GetClientDivisionFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Invoice.Client.Division"].options = data;
      });
    } else if($event.field == 'ClientSubDiv'){
      this._autopassService.GetClientSubDivisionFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Invoice.Client.SubDivision"].options = data;
      });
    } else if($event.field == 'Invoice.Client.Location'){
      this._autopassService.GetClientLocationFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Invoice.Client.Location"].options = data;
      });
    } else if($event.field == 'Invoice.Client.SubLocation'){
      this._autopassService.GetClientSubLocationFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Invoice.Client.SubLocation"].options = data;
      });
    } else if($event.field == 'Invoice.Client.Address.Country'){
      this._autopassService.GetClientCountryCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Invoice.Client.Address.Country"].options = data;
      });
    } else if($event.field == 'County'){
      this._autopassService.GetClientCountyCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.County"].options = data;
      });
    } else if($event.field == 'Invoice.CarrierId'){
      this._autopassService.GetCarrierIDFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Invoice.CarrierId"].options = data;
      });
    } else if($event.field == 'Carrier.Name'){
      this._autopassService.GetCarrierShortNameFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.Name"].options = data;
      });
    } else if($event.field == 'Carrier.Title'){
      this._autopassService.GetCarrierFullNameFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.Title"].options = data;
      });
    } else if($event.field == 'Carrier.Code'){ 
      this._autopassService.GetCarrierSCACFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields['Carrier.Code'].options = data;
      });
    } else if($event.field == 'Carrier.Region'){ 
      this._autopassService.GetCarrierRegionFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.Region"].options = data;
      });
    } else if($event.field == 'Carrier.Location'){
      this._autopassService.GetCarrierLocationFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields['Carrier.Location'].options = data;
      });
    } else if($event.field == 'Carrier.SubLocation'){
      this._autopassService.GetCarrierSubLocationFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.SubLocation"].options = data;
      });
    } else if($event.field == 'CarrierCurrency'){
      this._autopassService.GetCarrierCurrencyFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.CarrierCurrency.options = data;
      });
    } else if($event.field == 'Carrier.Country'){
      this._autopassService.GetCarrierCountryCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields['Carrier.Country'].options = data;
      });
    } else if($event.field == 'Carrier.City'){
      this._autopassService.GetCarrierCityFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.City"].options = data;
      });
    } else if($event.field == 'Carrier.Postcode'){
      this._autopassService.GetCarrierPostCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.Postcode"].options = data;
      });
    }
    if($event.field == 'ClientCarrier.ClientCarrierId'){
      this._autopassService.GetClientCarrierIdFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["ClientCarrier.ClientCarrierId"].options = data;
      });
    } else if($event.field == 'ClientCarrier.GP1'){
      this._autopassService.GetClientCarrierGP1Filter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["ClientCarrier.GP1"].options = data;
      });
    } else if($event.field == 'ClientCarrier.GP2'){
      this._autopassService.GetClientCarrierGP2Filter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["ClientCarrier.GP2"].options = data;
      });
    }
    if($event.field == 'Currency'){
      this._autopassService.GetCurrencyByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.Currency.options = data;
      });
    } else if($event.field == 'Status'){
      this._autopassService.GetInvoiceStatusByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Status"].options = data;
      });
    } 
    if($event.field == 'InvoiceShipment.ShipmentMode'){
      this._autopassService.GetShipModeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.ShipmentMode"].options = data;
      });
    } else if($event.field == 'InvoiceShipment.ServiceLevel'){
      this._autopassService.GetSrvceTypeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.ServiceLevel"].options = data;
      });
    } else if($event.field == 'InvoiceShipment.OriginPostcode'){
      this._autopassService.GetGeoPostCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.OriginPostcode"].options = data;
      });
    } else if($event.field == 'InvoiceShipment.DestinationPostcode'){
      this._autopassService.GetGeoPostCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.DestinationPostcode"].options = data;
      });
    } else if($event.field == 'InvoiceShipment.Origin'){
      this._autopassService.GetShipmentOriginStateFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.Origin"].options = data;
      });
    } else if($event.field == 'InvoiceShipment.OriginCity'){
      this._autopassService.GetShipmentCityFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.OriginCity"].options = data;
      });
    } else if($event.field == 'InvoiceShipment.FreightTerms'){
      this._autopassService.GetFreightTermFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.FreightTerms"].options = data;
      });
    }else if($event.field == 'InvoiceShipment.ShipmentCurrency'){
        this._autopassService.GetCurrencyByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
        { 
          this.config.fields["InvoiceShipment.ShipmentCurrency"].options = data;
        });
    } else if($event.field == 'InvoiceShipment.OriginCountryCode' ){
      this._autopassService.GetCountryCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.OriginCountryCode"].options = data;
      });
    } else if($event.field == 'InvoiceShipment.DestinationPortcode'){
      this._autopassService.GetGeoPortCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.DestinationPortcode"].options = data;
      });
    } else if($event.field == 'Accessorial'){
      this._autopassService.GetAccessorialNameFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.Accessorial.options = data;
      });
    }
  }

  resetPage()
  {
    this._document.defaultView.location.reload();
  }


  public saveAutopass(query){

    this.filterForFilterClientId = [];
    this.GET_CONDITION_PROPERTY(query.rules);

    let input: any = {
      Filter: this.filter,
      FilterLine: query,
      FilterClientCarrierFilters: this.filterForFilterClientId
    };

    this._autopassService.SaveAutopass(input).subscribe((filter: any) => 
    {
      this.filter = filter;
      this.sucessMessage();
    })
  }

  GET_CONDITION_PROPERTY(rules: Array<any>){

    var filteredRules: Array<any> =  rules.filter(x => x.hasOwnProperty('dataType') && x.dataType == "Condition")

    filteredRules.forEach(x => {
      if(x.hasOwnProperty('rules')){
        x.rules.forEach(d => {
          if(d.entity == 'clientProfile'){
            this.filterForFilterClientId.push({
              Table: 'Client',
              Values: Array.isArray(d.value) ? d.value : [`'${d.value}'`],
              Column: d.field
            });
          }
          if(d.entity == 'clientCarrierProfile'){
            this.filterForFilterClientId.push({
              Table: 'ClientCarrier',
              Values: Array.isArray(d.value) ? d.value : [`'${d.value}'`],
              Column: d.field
            });
          }
          if(d.entity == 'carrierProfile'){
            this.filterForFilterClientId.push({
              Table: 'Carrier',
              Values: Array.isArray(d.value) ? d.value : [`'${d.value}'`],
              Column: d.field
            });
          }
        });
      }
    });
  }

  public saveAsFilter(){
    this.filter.Id = 0;
    this.filter.TabTitle = this.filter.ClientCode;
    this.isSaveAsFilter = true;
  }
}
